type TFlatRecord = Record<string, string>;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export const getErrors = (errorResponse: unknown) => {
  if (typeof errorResponse === 'string') {
    return errorResponse;
  }

  if (isRecord(errorResponse)) {
    if (typeof errorResponse.error_msg === 'string') return errorResponse.error_msg;
    if (typeof errorResponse.error_message === 'string') return errorResponse.error_message;
    if (typeof errorResponse.message === 'string') return errorResponse.message;

    const res = flatten(errorResponse);
    if (Object.keys(res).length) {
      const msgKey = Object.keys(res).find(
        (item) => item.indexOf('message') > 0 || item.indexOf('msg') > 0 || item.indexOf('message') > 0
      );

      if (msgKey) {
        return res[msgKey as keyof typeof res];
      }

      const [k] = Object.keys(res);
      return res[k as keyof typeof res];
    }
  }
};

function traverseAndFlatten(currentNode: Record<string, unknown>, target: TFlatRecord, flattenedKey?: string) {
  for (const key in currentNode) {
    // eslint-disable-next-line no-prototype-builtins
    if (currentNode.hasOwnProperty(key)) {
      let newKey;
      if (flattenedKey === undefined) {
        newKey = key;
      } else {
        newKey = flattenedKey + '.' + key;
      }

      const value = currentNode[key];
      if (isRecord(value)) {
        traverseAndFlatten(value, target, newKey);
      } else {
        target[newKey] = String(value);
      }
    }
  }
}

function flatten(obj: Record<string, unknown>) {
  const flattenedObject: TFlatRecord = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
}
